import styled, { keyframes } from 'styled-components';
import DrawerHeader from './DrawerHeader';
import { useSelector } from 'react-redux';
import SearchResults from '../search/SearchResults';
import { useCallback } from 'react';
import { MapMode } from '../../types';
import CompoundDrawer from '../compound/CompoundDrawer';
import { useRouter } from 'next/router';
import CalculateDistanceDrawer from '../calculate-distance/CalculateDistanceDrawer';

interface DrawerProps {
  isSahel?: boolean;
}

const Drawer = ({ isSahel }: DrawerProps) => {
  const { locale } = useRouter();
  const mapMode = useSelector((state: any) => state.map.mapMode);
  const renderDrawer = useCallback(() => {
    if (mapMode === MapMode.SEARCH) {
      return <SearchResults />;
    }
    if (mapMode === MapMode.COMPOUND) {
      return <CompoundDrawer />;
    }
    if (mapMode === MapMode.CalculateDistance) {
      return <CalculateDistanceDrawer isSahel={isSahel} />;
    }
  }, [mapMode]);

  return (
    <Container className="hide-scrollbar" mapMode={mapMode} locale={locale}>
      <DrawerHeader
        headerText={mapMode === MapMode.SEARCH ? 'compounds_on_map' : ''}
      />

      <div className="drawer-body hide-scrollbar">{renderDrawer()}</div>
    </Container>
  );
};

const slideInLTR = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideInRTL = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

const Container = styled.div<{ mapMode: MapMode; locale: string | undefined }>`
  position: absolute;
  width: ${props => (props.mapMode === MapMode.SEARCH ? '358px' : '450px')};
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding-bottom: ${props =>
    props.mapMode === MapMode.COMPOUND ? '90px' : '32px'};
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.25);
  z-index: 99;
  /* overflow-x: hidden; */
  inset-inline-end: 0;
  flex-shrink: 0;
  animation: ${props => (props.locale === 'ar' ? slideInRTL : slideInLTR)} 0.5s
    ease-in;

  .drawer-body {
    height: calc(100vh - 116px);
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
    padding: 16px 24px;
    gap: 16px;
    flex-shrink: 0;
  }
`;

export default Drawer;
